import React from 'react';
import { translate } from 'react-jhipster';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

interface CustomerCommodityCardProps {
  customerSoldCommodities: any[];
  lang?: string;
}

export const CustomerCommodityCard = ({ customerSoldCommodities, lang = 'en' }: CustomerCommodityCardProps) => {
  const cellSx = { borderBottom: 'none', textAlign: lang === 'en' ? 'left' : 'right' } as const;

  return (
    <Paper className="summary-paper">
      <Typography variant="subtitle1" fontWeight={600} mb={2} letterSpacing="-0.01em" component="div">
        {translate('home.topInfo.myCommodity')}
      </Typography>
      <TableContainer sx={{ maxHeight: 180, marginTop: '20px' }}>
        <Table size="small">
          <TableBody>
            {customerSoldCommodities?.map(commodity => (
              <TableRow key={commodity.id}>
                <TableCell sx={cellSx}>{commodity.name}</TableCell>
                <TableCell align="right" sx={cellSx}>{commodity.amount.toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default CustomerCommodityCard;
